import React, { FunctionComponent, ReactNode } from "react";
import {
  Combobox,
  Label,
  ValidationMessage,
} from "@gjensidige/builders-components";

type Item =
  | string
  | {
      value?: string;
      label?: React.ReactNode;
    };

interface Props {
  id: string;
  labelText: ReactNode;
  value?: Item | Item[];
  invalid?: boolean;
  onChange?: (values: Item[], inputValue: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  errorText?: ReactNode;
  type?:
    | "checkbox"
    | "email"
    | "number"
    | "password"
    | "radio"
    | "search"
    | "switch"
    | "tel"
    | "text"
    | "url";
  options?: Item | Item[];
}

const FormDropdown: FunctionComponent<Props> = ({
  invalid,
  onChange,
  options,
  value,
  onBlur,
  errorText,
  id,
  labelText,
  type,
}) => {
  return (
    <div>
      <Label htmlFor={id}>{labelText}</Label>
      <Combobox
        id={id}
        name={id}
        onChange={onChange}
        onBlur={onBlur}
        invalid={invalid}
        values={value}
        options={options}
      />
      <ValidationMessage htmlFor={id} hidden={!invalid} invalid={invalid}>
        {errorText}
      </ValidationMessage>
    </div>
  );
};

export default FormDropdown;
